import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Competencies } from '~/shared/data-contract/job-profile';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useCompetencies = (): UseQueryResult<Competencies, Error> => {
    const { fetchCompetencies } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchCompetencies();

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: jobArchitectureKeys.competencies(),
        throwOnError: false,
    });
};
